<template>
  <div class="motor-info-menu">
    <div class="heading d-flex justify-content-between">
      <span class="title">{{ motor ? translate(motor.name) : $t('motor.menu.noMotorTitle') }}</span>
    </div>
    <stats-item
      tooltip-key="tooltip_motorconfig_type_info_max_torque"
      :label="$t('motor.menu.maxContinuousTorque')"
      :unit="getUnitString"
      :value="getUnitValue(motor ? motor.rated_torque : null)"
      :has-warning="hasWarning(getTorqueCalculation(preferences.pressure, preferences.cc), getValue(motor ? motor.rated_torque : null))"
      :warning="$t('motor.menu.maxContinuousTorqueWarning')"
    />
    <stats-item
      tooltip-key="tooltip_motorconfig_type_info_intermittent"
      :label="$t('motor.menu.intermittent')"
      :unit="getUnitString"
      :value="getUnitValue(motor ? motor.intermittent_coupling : null)"
      :has-warning="hasWarning(getTorqueCalculation(preferences.pressure, preferences.cc), getValue(motor ? motor.intermittent_coupling : null))"
      :warning="motor ? motor.intermittent_text : ''"
    />
    <stats-item
      tooltip-key="tooltip_motorconfig_type_info_peak"
      :label="$t('motor.menu.nominalPressure')"
      :unit="getUnitString"
      :value="getUnitValue(motor ? motor.max_torque : null)"
      :has-warning="hasWarning(getTorqueCalculation(preferences.pressure, preferences.cc), getValue(motor ? motor.max_torque : null))"
      :warning="motor ? motor.max_text : ''"
    />
    <stats-item
      tooltip-key="tooltip_motorconfig_type_info_omw"
      :label="$t('motor.menu.cmRev')"
      unit="cc"
      :value="getValue(motor ? motor.cm_rev : null)"
    />
    <stats-item
      tooltip-key="tooltip_motorconfig_type_info_max_rpm"
      :label="$t('motor.menu.maxRpm')"
      unit="rpm"
      :value="getValue(motor ? motor.max_rpm : null)"
      :has-warning="hasWarning(getRpmCalculation(preferences.lpm, preferences.cc), getValue(motor ? motor.max_rpm : null))"
      :warning="$t('motor.menu.maxRpmWarning')"
    />
    <stats-item
      tooltip-key="tooltip_motorconfig_type_info_min_rpm"
      :label="$t('motor.menu.minRpm')"
      unit="rpm"
      :value="getValue(motor ? motor.min_rpm : null)"
      :has-warning="preferences.lpm !== 0 && preferences.cc !== 0 && hasWarning(getValue(motor ? motor.min_rpm : null), getRpmCalculation(preferences.lpm, preferences.cc))"
      warning="The minimum rpm of the selected motor is too low. Choose a different motor or increase the oilflow."
    />
    <stats-item
      tooltip-key="tooltip_motorconfig_type_info_max_pressure"
      :label="$t('motor.menu.maxPressure')"
      unit="bar"
      :value="getValue(motor ? motor.max_pressure : null)"
      :has-warning="hasWarning(preferences.pressure, getValue(motor ? motor.max_pressure : null))"
      :warning="$t('motor.menu.maxPressureWarning')"
    />
    <stats-item
      tooltip-key="tooltip_motorconfig_type_info_as"
      :label="$t('motor.menu.outgoingAs')"
      unit=""
      :value="motor ? motor.outgoing_as : '0 mm'"
    />
  </div>
</template>

<script>
import StatsItem from '@/components/hose/components/StatsItem';
import { mapGetters, mapState } from 'vuex';
import { hasWarning, getTorqueCalculation, getValueByUnit, getRpmCalculation } from '@/helpers/motorCalculations';
import { round } from '@/helpers/calculations';

export default {
  name: 'MotorInfoMenu',
  components: {
    StatsItem,
  },
  computed: {
    ...mapGetters({
      preferences: 'build/motorConfig/getMotorPreferences',
      types: 'build/motorConfig/getAllMotorTypes',
      getMotorById: 'build/motorConfig/motors/byId',
    }),
    getUnitString() {
      return this.preferences.unit === 'newton' ? 'Nm' : 'Kgm';
    },
    motor() {
      return this.getMotorById[this.preferences.selectedMotor];
    },
  },
  methods: {
    getValue(value) {
      return value !== null ? round(value) : 0;
    },
    getUnitValue(value) {
      return value !== null ? round(getValueByUnit(value)) : 0;
    },
    hasWarning,
    getTorqueCalculation,
    getRpmCalculation
  },
};
</script>

<style scoped lang="scss">
.motor-info-menu {
  min-width: 270px;
  max-width: 270px;
  margin-top: 20px;
  margin-left: auto;
  grid-row-start: 4;
  grid-row-end: 5;
  padding: 20px 16px;
  background-color: #FAFAFA;
  border-right: 2px solid #EBEBEB;
  border-bottom: 2px solid #EBEBEB;
}
</style>